<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h11 sigilNotInTOC" id="heading_id_2"><span class="textStyle6">CAST OF CHARACTERS</span></h1>
<p class="hang"><span class="textStyle7">Roberta Grey</span></p>
<p class="hang"><span class="textStyle7">Lord Charles Lamprey</span></p>
<p class="hang"><span class="textStyle7">Lady Charles Lamprey</span></p>
<p class="hang"><span class="textStyle7">Henry Lamprey,</span> <span class="textStyle8">their eldest son</span></p>
<p class="hang"><span class="textStyle7">Friede Lamprey (Frid),</span> <span class="textStyle8">their elder daughter</span></p>
<p class="hang"><span class="textStyle7">Colin And Stephen Lamprey,</span> <span class="textStyle8">twins, their second and third sons</span></p>
<p class="hang"><span class="textStyle7">Patricia Lamprey (Patch),</span> <span class="textStyle8">their second daughter</span></p>
<p class="hang"><span class="textStyle7">Michael Lamprey (Mike),</span> <span class="textStyle8">their youngest son</span></p>
<p class="hang"><span class="textStyle7">Mrs. Burnaby (Nanny),</span> <span class="textStyle8">their nurse</span></p>
<p class="hang"><span class="textStyle7">Baskett,</span> <span class="textStyle8">their butler</span></p>
<p class="hang"><span class="textStyle7">Cora Blackburn,</span> <span class="textStyle8">their parlour-maid</span></p>
<p class="hang"><span class="textStyle7">Stamford,</span> <span class="textStyle8">a commissionaire</span></p>
<p class="hang"><span class="textStyle7">Grimball,</span> <span class="textStyle8">a “bum”</span></p>
<p class="hang"><span class="textStyle7">The Lady Katherine Lobe,</span> <span class="textStyle8">aunt to Lord Charles</span></p>
<p class="hang"><span class="textStyle7">Gabriel, Marquis Of Wutherwood And Rune (Uncle G.),</span> <span class="textStyle8">elder brother to Lord Charles</span></p>
<p class="hang"><span class="textStyle7">Violet, Marchioness Of Wutherwood And Rune (Aunt V.),</span> <span class="textStyle8">his wife</span></p>
<p class="hang"><span class="textStyle7">Giggle,</span> <span class="textStyle8">their chauffeur</span></p>
<p class="hang"><span class="textStyle7">Tinkerton,</span> <span class="textStyle8">Lady Wutherwood’s maid</span></p>
<p class="hang"><span class="textStyle7">Dr. Kantripp,</span> <span class="textStyle8">the Lampreys’ doctor</span></p>
<p class="hang"><span class="textStyle7">Sir Matthew Cairnstock,</span> <span class="textStyle8">a brain specialist</span></p>
<p class="hang"><span class="textStyle7">Dr. Curtis,</span> <span class="textStyle8">police surgeon</span></p>
<p class="hang"><span class="textStyle7">Detective-Inspector Fox</span> <span class="textStyle8">of the Central Branch, Criminal Investigation Department</span></p>
<p class="hang"><span class="textStyle7">Chief Detective-Inspector Alleyn</span> <span class="textStyle8">of the Central Branch, Criminal Investigation Department</span></p>
<p class="hang"><span class="textStyle7">Detective-Sergeant Bailey,</span> <span class="textStyle8">a finger-print expert</span></p>
<p class="hang"><span class="textStyle7">Detective-Sergeant Thompson,</span> <span class="textStyle8">a photographic expert</span></p>
<p class="hang"><span class="textStyle7">Police-Constable Martin</span></p>
<p class="hang"><span class="textStyle7">Police-Constable Gibson,</span> <span class="textStyle8">a police-constable who has read “Macbeth”</span></p>
<p class="hang"><span class="textStyle7">Detective-Sergeant Campbell,</span> <span class="textStyle8">on duty at 24 Brummell Street</span></p>
<p class="hang"><span class="textStyle7">Nigel Bathgate,</span> <span class="textStyle8">Watson to Mr. Alleyn</span></p>
<p class="hang"><span class="textStyle7">Mrs. Moffatt,</span> <span class="textStyle8">housekeeper at 24 Brummell Street</span></p>
<p class="hang"><span class="textStyle7">Moffatt,</span> <span class="textStyle8">her husband</span></p>
<p class="hang"><span class="textStyle7">Mr. Rattisbon,</span> <span class="textStyle8">solicitor</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FrontOther01.vue?56df2a3e